<template>
  <Control class="cx_numric_box" :title="title" :isEdit="isEdit && enabled" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"   :editor="editor"   :enabled="enabled" :tooltip="tooltip"  :key="title" :hasValue="value != nullValue">
    <template slot="read">{{value == null ? nullText : $api.formatter.formatNumber(value,decimals) }}<span v-if="suffix" class="cx_suffix">{{suffix}}</span></template>
    <template slot="edit">
      <div class="cx_numric_box_input">
      <slot name="before"></slot>
      <b-form-input ref="target" :class="{'is-invalid': validator.isInvalid}" v-model="internalValue" @focus.native="onFocus" @blur.native="onExit" type="text" autocomplete="off" :placeholder="placeholder" size="sm"></b-form-input><span v-if="suffix" class="cx_suffix">{{suffix}}</span>
      <slot name="after"></slot>      
      </div>
   </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
@Component
export default class NumericBox extends Vue  implements Components.IControl {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: number;
  @Prop({default:null}) public editor :Components.IEditor;
  @Prop({ default: false }) public required?: boolean;
  @Prop({default:''}) public placeholder?: string;  
  @Prop({default:null}) public max?: number;
  @Prop({default:null}) public min?: number;
  @Prop({default:null}) public more?: number;
  @Prop({default:null}) public less?: number;
  @Prop({default:null}) public decimals?: number; //表示桁数
  @Prop({default:null}) public decimalsInput?: number; //入力桁数  
  @Prop({default:0}) public nullValue:number;
 @Prop({default:true}) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop() public tooltip: string;
  @Prop({default:null}) public suffix: string;  
  public isEdit: boolean = true;
  public validator: Components.ControlValidator ;

  //2026-10-16 haramoto
  //以下の不自然な挙動を改善
  //バックスペース時で消すと0に戻り、0をバックスペースで消すとブランクになる
  //0の後ろにカーソルがある状態で入力すると0が置換され、0の前にカーソルがあると0が残る
  //マイナス入力ができない



  //当初はnullValue<=>nullText(非数値)という双方向変換だったが、nullValueの初期値をnullから0に変更し、非数値入力=>nullValue、null値バインド=>nullText表示という片方向変換に変更
  //nullValue(0)<=>nullText('0')の双方向変換に戻す(nullValueには0しか使用されていないため)
  public nullText: string = '0';


  created(){
    this.validator = new Components.ControlValidator(this,'tooltip',this.internalValidate);
     if (this.editor != null) this.editor.addControl(this);
    //初期値設定
     this.onValueChanged();
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }


  public internalValue : string = '';

  @Watch('internalValue')
  public onInternalValueChanged(){

    //無効な文字が含まれる場合は遅延更新する～同一スレッドだと無視される
    var matchs = this.internalValue.match('[\-]?[0-9]+([\.][0-9]*)?');
    if (matchs && matchs[0] != this.internalValue) {
      this.$nextTick(()=>this.internalValue=matchs[0]);
      return;
    }
    if (!matchs && this.internalValue !== '') {
      this.$nextTick(() => this.internalValue = '');
    }
    if (isNaN(Number.parseFloat(this.internalValue))){
      //入力中にデータソースを更新しようとするとマイナス(-)入力ができなかったりするので、フォーカスアウト時にリセットするように変更
      // this.$emit('update:value', this.nullValue);
    } else {
      this.$emit('update:value', Number(this.internalValue));
    }      
  }

  public onExit() {
    if (isNaN(Number.parseFloat(this.internalValue))){
      this.$emit('update:value', this.nullValue);
      this.internalValue =  this.nullText;
    }      
  }
  public onFocus(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    if (input) input.select();
  }

  @Watch('value')
  public onValueChanged(){
    // if (this.value == this.nullValue) {    
    if (this.value == null) {
      this.internalValue =  this.nullText;
    } else {
      this.internalValue = this.value.toString();
    }
    //バリデーションを更新する
    this.validator.update();
  }

  // public get internalValue(): string {
  //   if (this.value == this.nullValue) {
  //     return this.nullText;
  //   } else {
  //     return this.value.toString();
  //   }
  // }

  // public set internalValue(value: string) {

  //   //数値に変換できない場合はデータソースを更新しない
  //   if (isNaN(Number.parseFloat(value))){
  //     this.$emit('update:value', this.nullValue);
  //   } else {
  //     this.$emit('update:value', Number.parseFloat(value));
  //   }

  //   //入力値でバリデーションを実行する
  //   this.validator.update();
  // }

  public internalValidate(): string {
    const value = this.internalValue;
    //非活性の場合にバリデーションを除外
    if (this.enabled == false) return '';
        
    if (this.required == false && value == this.nullText) {
      return '';
    } 
    
    if (isNaN(Number.parseFloat(value))) {
      return '数値を入力してください';
    }


    if (value.indexOf('.')>0 && this.decimals != null && value.substring(value.indexOf('.')).length - 1 > this.decimals ){
      return '小数点以下の桁数は最大' + this.decimals + '桁です';
    }

    if (value.indexOf('.')>0 && this.decimalsInput != null && value.substring(value.indexOf('.')).length - 1 > this.decimalsInput ){
      return '小数点以下の桁数は最大' + this.decimalsInput + '桁です';
    }    
    const temp = Number.parseFloat(value);

    if (this.required && temp == 0) return '必須項目です';
    if (this.max != null && temp > this.max) {
      return  this.max.toString() + '以下の数値を指定してください';
    }

    if (this.less != null && temp >= this.less) {
      return  this.less.toString() + '未満の数値を指定してください';
    }

    if (this.min != null && temp < this.min) {
      return this.min.toString() + '以上の数値を指定してください';
    }
    if (this.more != null && temp <= this.more) {
      return  this.more.toString() + 'を超える数値を指定してください';
    }


    return '';

  }

}
</script>
<style lang="scss">
.cx_numric_box{
  .cx_numric_box_input{
    display: flex;
  }
  .cx_suffix{margin-left: 5px;}
}
</style>